import { useMutation, useQuery, useQueryClient } from "react-query";

import { cleaningEventKey } from "./keys";
import {
  callListCleaningEventsByDate,
  callListCleaningEventsByMap,
  callListCleaningEventsByRobot,
  callUpdateCleaningEventStatus,
} from "api/worker/cleaningEvent";
import { getWeekRangeFromDate } from "utils/date";
import { CleaningEventList } from "types/response/cleaningEvent";
import { CleaningEventStatus } from "types/type";

type Params = {
  baseDate?: Date;
  enabled?: boolean;
};

export const useListCleaningEventByDateQuery = (input?: Params) => {
  const baseDate = input?.baseDate;
  const enabled = input?.enabled;
  const { monday, sunday } = getWeekRangeFromDate(baseDate ?? new Date());
  return useQuery({
    queryKey: cleaningEventKey.listByDate(monday, sunday),
    queryFn: () =>
      callListCleaningEventsByDate({ startDate: monday, endDate: sunday }),
    enabled: enabled ?? true,
    select(data) {
      return {
        cleaningEvents: data,
        startDate: monday,
        endDate: sunday,
      };
    },
  });
};

type ListByRobotParams = {
  robotId: string;
  enabled?: boolean;
};

export const useListCleaningEventByRobotQuery = (input: ListByRobotParams) => {
  return useQuery({
    queryKey: cleaningEventKey.listByRobot(input.robotId),
    queryFn: () => callListCleaningEventsByRobot({ robotId: input.robotId }),
    enabled: input.enabled ?? true,
    // select(data) {
    //   return {
    //     cleaningEvents: data,
    //     startDate: monday,
    //     endDate: sunday,
    //   };
    // },
  });
};

type ListByMapParams = {
  mapId: string;
  enabled?: boolean;
};

export const useListCleaningEventByMapQuery = (input: ListByMapParams) => {
  const { mapId, enabled } = input;
  return useQuery({
    queryKey: cleaningEventKey.listByMap(mapId),
    queryFn: () => callListCleaningEventsByMap({ mapId }),
    enabled: enabled ?? true,
    // select(data) {
    //   return {
    //     cleaningEvents: data,
    //     startDate: monday,
    //     endDate: sunday,
    //   };
    // },
  });
};

type UseCleaningEventStatusParams = {
  baseDate: Date;
};
export const useUpdateCleaningEventStatus = (
  input: UseCleaningEventStatusParams
) => {
  const queryClient = useQueryClient();
  const { monday, sunday } = getWeekRangeFromDate(input.baseDate);

  return useMutation(callUpdateCleaningEventStatus, {
    onSuccess: (_updated, variables) => {
      queryClient.setQueryData<CleaningEventList | undefined>(
        cleaningEventKey.listByDate(monday, sunday),
        (prev) => {
          if (!prev) return prev;
          return prev.map((event) =>
            event.cleaningEventId === variables.cleaningId
              ? {
                  ...event,
                  manualCleaningStatus: variables.status as CleaningEventStatus,
                  manualCleaningDate: new Date(),
                }
              : event
          );
        }
      );
    },
  });
};
